import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { ClaimTemplateListScreen } from 'screens/claim-template';

export default withPermissions(ClaimTemplateListScreen, [
  GroupSecurity.ClaimTemplateRead,
]);
